module.exports = __webpack_public_path__ + "img/cluster.c568d4e7.svg";